import React, { forwardRef, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import { useSelector, useDispatch } from 'react-redux';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import * as icons from 'react-bootstrap-icons';
import CButton from 'Utils/Helpers/CButton';
import { clearCreateNew, setSelected } from '../../../../../Redux/slices/globalSlice';
import LackInformation from './LackInformation';
import Create from './Create';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function NewAppointment({}) {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [reset, setReset] = useState(true);
  const { appointmentTypes } = useSelector((state) => ({
    appointmentTypes: state.setting.appointmentTypes,
  }));

  const setShowDialog = () => {
    setShow(true);
    dispatch(setSelected(null));
    dispatch(clearCreateNew());
    setReset(true);
  }

  const handleClose= () => {
    setShow(false);
  }

  return (
    <>
      <div className='home-btn-add'>
        <CButton
            text={'اضافه کردن نوبت جدید'}
            icon={<icons.PlusCircle/>}
            onClick={setShowDialog}
            className='home-btn h-lg with-shadow with-OP07'
        />
      </div>
      {
        show &&
        <Dialog
          open={show}
          TransitionComponent={Transition}
          keepMounted
          fullWidth={true}
          maxWidth={'xs'}
          onClose={handleClose}
          aria-describedby="alert-dialog-slide-appointment-edit"
        >
          <DialogTitle>
            {"نوبت جدید"}
            <div className='close-btn' onClick={handleClose}>
              <icons.X/>
            </div>
          </DialogTitle>
          {
            (appointmentTypes && appointmentTypes.length !== 0)
            ? <Create
                handleClose={handleClose}
                reset={reset}
                setReset={(e) => setReset(e)}
              /> : <LackInformation />
          }
        </Dialog>
      }
    </>
  );
}